var E = /* @__PURE__ */ ((r) => (r.DEFAULT = "", r.LEFT = "left", r.CENTER = "center", r.RIGHT = "right", r))(E || {});
export {
  E as RocheUISocialMediaAlignment
};
